/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*****************************!*\
  !*** ./src/js/ai-search.js ***!
  \*****************************/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//import { levenshtein } from './levenshtein';
//import { synonyms } from './synonyms';
// function findSynonyms(query) {
//     return Object.keys(synonyms).flatMap(key => {
//         if (key.toLowerCase().startsWith(query.toLowerCase())) {
//             return synonyms[key];
//         }
//         return [];
//     });
// }
function stripParameters(url) {
  var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "https://crepslocker.com";
  if (!url || typeof url !== "string") {
    return url; // Return original URL if it's not valid
  }
  try {
    var urlObj = new URL(url, baseUrl);
    urlObj.searchParams["delete"]("_pos");
    urlObj.searchParams["delete"]("_sid");
    urlObj.searchParams["delete"]("_ss");
    urlObj.searchParams["delete"]("variant"); // Add this line to remove the variant parameter
    return urlObj.toString();
  } catch (error) {
    console.error("Error stripping parameters:", error);
    return url; // If there's an error, return the original URL
  }
}
var LiveSearch = /*#__PURE__*/function () {
  function LiveSearch(_ref) {
    var _this = this;
    var input = _ref.input,
      suggestions = _ref.suggestions,
      resultsContainer = _ref.resultsContainer,
      searchUrl = _ref.searchUrl,
      _ref$debounceTime = _ref.debounceTime,
      debounceTime = _ref$debounceTime === void 0 ? 250 : _ref$debounceTime;
    _classCallCheck(this, LiveSearch);
    this.input = input;
    this.resultsContainer = resultsContainer;
    this.searchUrl = searchUrl;
    this.debounceTime = debounceTime;
    this.searchWrapper = document.querySelector("#search-wrapper");
    this.preSearch = document.querySelector("#presearch");
    this.noResults = document.querySelector("#no-results-msg");
    this.noResultsTerm = document.querySelector("#no-results-term");
    this.suggestions = suggestions || [];
    this.suggestionsContainer = document.getElementById("suggestions-container");
    //this.trendingContainer = document.getElementById('trending-container');
    this.paginationContainer = document.querySelector(".pagination-container");
    this.searchUrl = "/search?query=";
    // this.voiceSearchButton = document.getElementById('voice-search');
    // this.voiceSearchButton.addEventListener('click', () => this.startVoiceSearch());
    this.searchModal = document.querySelector("[data-live-search]");
    this.collectionPriorityRules = [];
    this.collectionPriorityMinChars = 2;
    var priorityData = this.searchModal.querySelector("[data-collection-priority-rules]");
    if (priorityData) {
      try {
        var prioritySettings = JSON.parse(priorityData.textContent);
        if (Array.isArray(prioritySettings.rules)) this.collectionPriorityRules = prioritySettings.rules;
        this.collectionPriorityMinChars = Math.max(2, Number(prioritySettings.minimumCharacters) || 2);
      } catch (error) {
        // Invalid or missing merchant rules fall back to the normal search order.
      }
    }
    this.toggleButtons = document.querySelectorAll("[data-search-toggle]");
    this.bindToggleButtons();
    this.closeButton = document.querySelector("#close-results");
    this.searchInfo = document.querySelector("#search-info");
    this.closeButton.addEventListener("click", function () {
      _this.hideModal();
    });
    if (this.input) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));
      this.input.addEventListener("input", this.debounce(this.onChange, debounceTime).bind(this));
    }
    input.addEventListener("focus", function () {
      var query = input.value.trim();
      _this.searchWrapper.classList.remove("hidden");
      if (!input.value.trim()) {
        //this.trendingContainer.classList.remove('hidden');
      }
      if (query.length >= 1) {
        _this.search(query);
      }
    });
    var selectedIndex = -1;
    this.input.addEventListener("keydown", function (event) {
      var results = _this.resultsContainer.querySelectorAll(".search-result");
      var maxIndex = results.length - 1;
      if (event.key === "ArrowDown") {
        selectedIndex = Math.min(selectedIndex + 1, maxIndex);
        _this.highlightResult(selectedIndex);
      } else if (event.key === "ArrowUp") {
        selectedIndex = Math.max(selectedIndex - 1, -1);
        _this.highlightResult(selectedIndex);
      } else if (event.key === "Enter" && selectedIndex >= 0) {
        event.preventDefault();
        var selectedResult = results[selectedIndex];
        if (selectedResult) {
          window.location.href = selectedResult.href;
        }
      }
    });
  }
  return _createClass(LiveSearch, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      this.searchInput.addEventListener("input", function (e) {
        return _this2.search(e.target.value);
      });
    }
  }, {
    key: "bindToggleButtons",
    value: function bindToggleButtons() {
      var _this3 = this;
      if (this.toggleButtons.length > 0) {
        this.toggleButtons.forEach(function (button) {
          button.addEventListener("click", function () {
            _this3.toggleSearchModal();
          });
        });
      } else {
        console.error("No elements found with data-search-toggle attribute");
      }
    }
  }, {
    key: "createOverlay",
    value: function createOverlay() {
      var _this4 = this;
      var overlay = document.createElement("div");
      overlay.classList.add("search-overlay", "fixed", "inset-0", "w-full", "h-full", "bg-black/30", "z-[300]", "transition-all");
      overlay.addEventListener("click", function () {
        return _this4.hideModal();
      });
      return overlay;
    }
  }, {
    key: "onFormReset",
    value: function onFormReset() {
      this.input.value = "";
      this.hideResults();
      document.querySelector("#resetButton").classList.add("hidden");
      // Add any other behavior you want on form reset
    }
  }, {
    key: "onChange",
    value: function onChange(event) {
      var query = event.target.value.trim();
      if (query.length > 0) {
        //this.showHints(query);
        this.searchWrapper.classList.remove("hidden");
        document.querySelector("#resetButton").classList.remove("hidden");
      } else {
        //this.searchWrapper.classList.add('hidden');
        this.hideResults();
        //console.log('search length 0');
        document.querySelector("#resetButton").classList.add("hidden");
      }
      if (query.length < 1) {
        this.hideResults();
        return;
      }
      this.search(query);
    }
  }, {
    key: "toggleSearchModal",
    value: function toggleSearchModal() {
      var _this5 = this;
      this.searchModal.classList.toggle("active");
      document.body.classList.toggle("search-active");
      this.preSearch.classList.remove("hidden");
      if (this.searchModal.classList.contains("active")) {
        setTimeout(function () {
          //console.log('focusing input');
          _this5.input.focus();
        }, 200);
        // Append overlay to body
        //this.trendingContainer.classList.remove('hidden');
        document.body.appendChild(this.createOverlay());
      } else {
        //this.trendingContainer.classList.add('hidden');
        // Remove overlay from body
        var overlay = document.querySelector(".search-overlay");
        if (overlay) overlay.remove();
      }
    }
  }, {
    key: "highlightResult",
    value: function highlightResult(index) {
      var results = this.resultsContainer.querySelectorAll(".search-result");
      results.forEach(function (result, i) {
        if (i === index) {
          result.classList.add("border-yellow-500");
        } else {
          result.classList.remove("border-yellow-500");
        }
      });
    }
  }, {
    key: "debounce",
    value: function debounce(func, wait) {
      var timeout;
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        var context = this;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          return func.apply(context, args);
        }, wait);
      };
    }

    // showHints(query) {
    //     // const filteredSuggestions = this.suggestions.filter(suggestion =>
    //     //     suggestion.toLowerCase().startsWith(query.toLowerCase())
    //     // );

    //     const synonymSuggestions = findSynonyms(query);
    //     const allSuggestions = [...synonymSuggestions];

    //     const suggestionItems = allSuggestions
    //         .map(
    //             suggestion => `<div class="text-black text-[12px] cursor-pointer hover:underline leading-none pb-1">${suggestion}</div>`
    //         )
    //         .join('');

    //     if (allSuggestions.some(suggestion => suggestion.toLowerCase() === query.toLowerCase())) {
    //         this.suggestionsContainer.innerHTML = '';
    //     } else {
    //         this.suggestionsContainer.innerHTML = suggestionItems;
    //     }

    //     const suggestionElements = this.suggestionsContainer.querySelectorAll('div');
    //     suggestionElements.forEach(element => {
    //         element.addEventListener('click', event => {
    //             this.input.value = event.target.textContent;
    //             this.suggestionsContainer.innerHTML = '';
    //             this.search(event.target.textContent);
    //         });
    //     });
    // }
  }, {
    key: "updatePaginationActiveState",
    value: function updatePaginationActiveState(activePage) {
      this.paginationContainer.querySelectorAll(".pagination-btn").forEach(function (btn) {
        var page = parseInt(btn.dataset.page, 5);
        if (page === activePage) {
          btn.classList.add("active");
        } else {
          btn.classList.remove("active");
        }
      });
    }
  }, {
    key: "search",
    value: function () {
      var _search = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(query) {
        var page,
          searchUrl,
          response,
          data,
          _args = arguments,
          _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              page = _args.length > 1 && _args[1] !== undefined ? _args[1] : 1;
              if (!(query.length > 0)) {
                _context.n = 6;
                break;
              }
              _context.p = 1;
              searchUrl = "/search?q=".concat(encodeURIComponent(query), "&page=").concat(page, "&view=json"); // console.log(searchUrl);
              _context.n = 2;
              return fetch(searchUrl);
            case 2:
              response = _context.v;
              _context.n = 3;
              return response.json();
            case 3:
              data = _context.v;
              this.displayResults(data);
              // console.log(data);
              // console.log(window.routes.predictive_search_url)
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              console.error("Error fetching search data:", _t);
            case 5:
              _context.n = 7;
              break;
            case 6:
              this.resultsContainer.innerHTML = "";
            case 7:
              return _context.a(2);
          }
        }, _callee, this, [[1, 4]]);
      }));
      function search(_x) {
        return _search.apply(this, arguments);
      }
      return search;
    }() // expandQueryWithSynonyms(query) {
    //     const terms = query.split(' ');
    //     const expandedTerms = terms.flatMap(term => synonyms[term.toLowerCase()] || term);
    //     return expandedTerms.join(' ');
    // }
  }, {
    key: "startVoiceSearch",
    value: function startVoiceSearch() {
      var _this6 = this;
      if (!("webkitSpeechRecognition" in window)) {
        alert("Your browser does not support voice search. Please try using Google Chrome.");
        return;
      }
      var recognition = new webkitSpeechRecognition();
      recognition.lang = "en-US";
      recognition.interimResults = false;
      recognition.maxAlternatives = 1;
      recognition.onresult = function (event) {
        var speechResult = event.results[0][0].transcript;
        _this6.input.value = speechResult;
        _this6.input.dispatchEvent(new Event("input"));
      };
      recognition.onerror = function (event) {
        console.error("Error occurred in recognition:", event.error);
      };
      recognition.start();
    }

    // Improved Levenshtein algorithm for more accurate search results
  }, {
    key: "modifiedLevenshtein",
    value: function modifiedLevenshtein(a, b) {
      var matrix = [];
      var searchTerm = a.toLowerCase();
      var title = b.toLowerCase();

      // Check for exact match first
      if (title.includes(searchTerm)) {
        // Split the title and search term into words
        var titleWords = title.split(/\s+/);
        var searchTermWords = searchTerm.split(/\s+/);

        // Check if all words in the search term are present as whole words in the title
        var allWordsMatch = true;
        var _iterator = _createForOfIteratorHelper(titleWords),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var word = _step.value;
            if (!searchTermWords.includes(word)) {
              allWordsMatch = false;
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (allWordsMatch) {
          console.log("ALL WORDS MATCH");
          return 0; // Return 0 if all words in the search term match whole words in the title
        }
      }

      // Initialize the matrix
      for (var i = 0; i <= b.length; i++) {
        matrix[i] = [i];
      }
      for (var j = 0; j <= a.length; j++) {
        matrix[0][j] = j;
      }

      // Populate the rest of the matrix
      for (var _i = 1; _i <= b.length; _i++) {
        for (var _j = 1; _j <= a.length; _j++) {
          if (b.charAt(_i - 1) === a.charAt(_j - 1)) {
            matrix[_i][_j] = matrix[_i - 1][_j - 1];
          } else {
            matrix[_i][_j] = Math.min(matrix[_i - 1][_j - 1] + 1,
            // substitution
            Math.min(matrix[_i][_j - 1] + 1,
            // insertion
            matrix[_i - 1][_j] + 1)); // deletion
          }
        }
      }
      return matrix[b.length][a.length];
    }
  }, {
    key: "prioritizeCollections",
    value: function prioritizeCollections(collections, terms) {
      var query = String(terms || "").trim().toLowerCase().replace(/\s+/g, " ");
      if (query.length < this.collectionPriorityMinChars) return collections;
      var priorityCollections = [];
      this.collectionPriorityRules.forEach(function (rule) {
        if (!rule || typeof rule.terms !== "string" || !Array.isArray(rule.collections)) return;
        var matches = rule.terms.split(/[,\n\r]+/).some(function (term) {
          var normalized = term.trim().toLowerCase().replace(/\s+/g, " ");
          return normalized && normalized.indexOf(query) === 0;
        });
        if (matches) priorityCollections = priorityCollections.concat(rule.collections);
      });
      if (!priorityCollections.length) return collections;
      var seen = new Set();
      return priorityCollections.concat(collections).filter(function (collection) {
        if (!collection || typeof collection.title !== "string" || typeof collection.url !== "string" || !collection.url) return false;
        var key = stripParameters(collection.url);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    }
  }, {
    key: "displayResults",
    value: function displayResults(data) {
      var _this7 = this;
      // A slower response for an earlier query must not replace newer results.
      if (!this.input.value.trim() || String(data.terms || "").trim().toLowerCase() !== this.input.value.trim().toLowerCase()) return;
      this.resultsContainer.classList.remove("hidden");
      //console.log('hide presearch / show results');
      this.preSearch.classList.add("hidden");
      var resultsCount = data.results_count || 0;
      var terms = data.terms;
      var results = data.results || [];
      //console.log(results);
      var collections = data.collections || [];
      var products = results.filter(function (result) {
        return result.object_type == "product";
      });
      var pages = results.filter(function (result) {
        return result.object_type === "page";
      });
      var articles = results.filter(function (result) {
        return result.object_type === "article";
      });
      var matchingCollections = "";
      if (terms) {
        var searchTerm = terms.toLowerCase();
        // Shopify already ranks these results by relevance (including Search & Discovery boosts).
        // Preserve that order before exclusions and the 18-product display limit.
        pages = pages.filter(function (page) {
          return page.title.toLowerCase().includes(searchTerm);
        });
        articles = articles.filter(function (article) {
          return article.title.toLowerCase().includes(searchTerm);
        });
        matchingCollections = collections.filter(function (collection) {
          return collection.title.toLowerCase().includes(searchTerm);
        });

        // use levenstein to sort the collection array also
        matchingCollections = matchingCollections.map(function (collection) {
          var distance = _this7.modifiedLevenshtein(searchTerm, collection.title.toLowerCase());
          return _objectSpread(_objectSpread({}, collection), {}, {
            _distance: distance
          });
        }).sort(function (a, b) {
          return a._distance - b._distance;
        });
        console.log(matchingCollections);
      } else {
        matchingCollections = collections;
      }
      // filter products to not include items with tag or title of damaged here, and slice that below instead?
      var filteredProducts = products.filter(function (product) {
        return !product.content.toLowerCase().includes("<!--if-->");
      });
      var limitedProducts = filteredProducts.slice(0, 18);
      var limitedcollections = matchingCollections.slice(0, 20);

      // collection synonyms
      // collections dont have access to synonyms, so we check if collection titles are contained in any of the product titles (that DO include synonyms results.)
      if (terms) {
        if (limitedcollections.length < 20) {
          var neededAdditions = 20 - limitedcollections.length;
          var additionalCollections = new Set(limitedcollections.map(function (col) {
            return col.title.toLowerCase();
          }));
          limitedProducts.every(function (product) {
            if (limitedcollections.length >= 20) {
              return false; // Exit the 'every' loop
            }
            var productTitle = product.title.toLowerCase();
            collections.some(function (collection) {
              var collectionTitle = collection.title.toLowerCase().replace(/\btrainers\b/, "").trim();
              if (productTitle.includes(collectionTitle) && !additionalCollections.has(collectionTitle)) {
                additionalCollections.add(collectionTitle);
                limitedcollections.push(collection); // Add the collection to limitedcollections
                return limitedcollections.length >= 20; // Exit the 'some' loop if enough collections are added
              }
              return false;
            });
            return true; // Continue the 'every' loop
          });

          // Remove duplicates from limitedcollections at the end
          limitedcollections = Array.from(new Set(limitedcollections));
        }
      }
      limitedcollections = this.prioritizeCollections(limitedcollections, terms).slice(0, 20);
      var collectionResults = this.formatResults(limitedcollections, "Collection");
      var productResults = this.formatResults(limitedProducts, "Product");
      //const collectionResults = this.formatResults(limitedcollections, 'Collection'); // Modify this line
      var pageResults = this.formatResults(pages, "Page");
      var articleResults = this.formatResults(articles, "Article");

      //handle single and no collection results
      var gridCols = limitedcollections.length == 1 ? "grid-cols-1" : "grid-cols-2";
      var noResultsHide = limitedcollections.length < 1 ? "hidden lg:grid" : "";
      var noCollectionFound = limitedcollections.length < 1 ? "<p class=\"text-[13px]\">No collections matching your search</p>" : "";
      if ((resultsCount === 0 && limitedcollections.length === 0) || !this.input.value.trim()) {
        //if no results or search is only spaces
        //this.trendingContainer.classList.remove('hidden');
        //this.resultsContainer.classList.add('hidden');
        this.noResults.classList.remove("hidden");
        //this.noResultsTerm.innerText = terms;
        this.noResultsTerm.innerText = new DOMParser().parseFromString(terms, "text/html").documentElement.textContent;
        this.hideResults();
      } else {
        //if there are results
        //this.trendingContainer.classList.add('hidden');
        this.noResults.classList.add("hidden");
        this.noResultsTerm.innerText = "";
      }
      this.resultsContainer.innerHTML = "\n            <div class=\"grid grid-cols-1 lg:grid-cols-8 lg:pt-2 gap-x-4\">\n                <div class=\"lg:col-span-2\">\n                    <div class=\"w-full\">\n                        <div class=\"search-section p-3 rounded-xl bg-[#fafafa] grid ".concat(gridCols, " lg:grid-cols-1 gap-x-2 mb-2 ").concat(noResultsHide, "\">\n                            <h3 class=\"text-sm font-bold uppercase mb-2 col-span-2 lg:col-span-1\">Collections</h3>\n                            ").concat(noCollectionFound, "\n                            ").concat(collectionResults.join(""), "\n                        </div>\n                        <div class=\"search-section pb-2 hidden\">\n                            <h3 class=\"text-sm font-bold uppercase mb-2\">Articles</h3>\n                            ").concat(articleResults.join(""), "\n                        </div>\n                        <div class=\"search-section pb-2 hidden\">\n                            <h3 class=\"text-sm font-bold uppercase mb-2\">Pages</h3>\n                            ").concat(pageResults.join(""), "\n                        </div>\n                    </div>\n                </div>\n                <div class=\"lg:col-span-6 \">\n                    <div class=\"w-full\">\n                        <div class=\"search-section\">\n                            <div class=\"flex items-center w-full mb-2 gap-x-2\"><h3 class=\"text-sm uppercase\"><strong>Products</strong> <span class=\"text-gray-500\">for '").concat(terms, "'</span></h3><div class=\"bg-gray-300 h-[1px] grow\"></div></div>\n                            <div class=\"grid grid-cols-4 lg:grid-cols-6 gap-x-4 gap-y-4\">\n                                ").concat(productResults.join(""), "\n                            </div>\n                            <a class=\"block text-[12px] text-gray-500 mt-5\" href=\"/search?q=").concat(encodeURIComponent(terms), "\">View all ").concat(resultsCount, " results for \"").concat(terms, "\"</a>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        ");
    }
  }, {
    key: "hideModal",
    value: function hideModal() {
      document.body.classList.remove("search-active");
      //this.trendingContainer.classList.add('hidden');
      this.searchModal.classList.remove("active");
      this.preSearch.classList.remove("hidden");
      this.input.value = "";
      this.input.blur();
      this.hideResults();

      // Remove overlay from body
      var overlay = document.querySelector(".search-overlay");
      if (overlay) overlay.remove();
    }
  }, {
    key: "hideResults",
    value: function hideResults() {
      //this.searchWrapper.classList.add('hidden');
      this.resultsContainer.classList.add("hidden");
      this.preSearch.classList.remove("hidden");
      //this.trendingContainer.classList.add('hidden');
    }
  }, {
    key: "checkForTag",
    value: function checkForTag(title) {
      var pattern = /\(W\)|\(GS\)|\(PS\)|\(TD\)/;
      var match = title.match(pattern);
      return match ? match[0] : null;
    }
  }, {
    key: "formatResults",
    value: function formatResults(items, type) {
      var _this8 = this;
      var searchTerm = this.input.value.trim().toLowerCase();
      return items.map(function (item) {
        var title = item.title;
        var type_tag = _this8.checkForTag(title);
        var typeTagDiv = "";
        if (type_tag) {
          //typeTagDiv = `<div class="h-full bg-white pl-1"><span class="font-bold">${type_tag}</span></div>`;
          title = title.replace(type_tag, "").trim(); //remove the tag from the title if there is one
          title = type_tag + " " + title;
        }
        item.url = stripParameters(item.url);
        if (searchTerm) {
          var index = title.toLowerCase().indexOf(searchTerm);
          if (index !== -1) {
            title = "".concat(title.slice(0, index), "<span class=\"highlight font-bold\">").concat(title.slice(index, index + searchTerm.length), "</span>").concat(title.slice(index + searchTerm.length));
          }
        }

        // //logic to span 2 col if only one collection result
        // let colSpanClass = '';
        // if (type == 'Collection' && items.length < 1) {
        //     console.log('One collection found');
        //     let colSpanClass = array.length === 1 ? 'col-span-2' : '';
        // }

        if (type === "Product") {
          return "\n                <div class=\"search-result product-result border border-transparent\">\n                    <a href=\"".concat(item.url, "\" class=\"flex flex-col\">\n                        <div class=\"relative pt-[100%]\">\n                         ").concat(item.image ? "<img src=\"".concat(item.image, "&width=300\" alt=\"").concat(item.title, "\" class=\"absolute top-0 left-0 w-full h-full object-contain\">") : "", "\n                        </div>\n                        <div class=\"w-full flex text-[13px] leading-none py-1 items-center justify-start\">\n                            <p class=\"shrink line-clamp-2 lg:line-clamp-1 leading-tight\">").concat(title, "</p>\n                        </div>\n                    </a>\n                </div>");
        } else {
          return "\n                <div class=\"search-result other-result border border-transparent\">\n                    <a href=\"".concat(item.url, "\" class=\"block font-normal text-[13px] leading-none hover:underline pb-2 mb-1 truncate\"> ").concat(title, "</a>\n                </div>");
        }
      });
    }
  }]);
}();
var liveSearch = new LiveSearch({
  input: document.getElementById("search-input"),
  resultsContainer: document.getElementById("results-container"),
  searchUrl: "/search?q=view=results"
});
/******/ })()
;
